import React, { forwardRef, useEffect, useMemo, useRef, useState } from 'react';

import { useParams } from 'react-router-dom';
import moment from 'moment';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import api from '../../api';

import BackBtn from '../../components/UI/BackBtn';
import { years } from '../../helpers';
import YearSelect from '../../components/common/YearSelect';
import EditMember from '../../components/Members/EditMember';
import TableRegistry from '../../components/Members/TableRegistry';
import {
  isAdmin,
  isCommandManagmentOrProjOffice,
  isProjectAdmin, isProjectTeam,
  isStratAdmin,
  isStrategyTeam,
} from '../../services/rolesSvc';
import useUserContext from '../../hooks/useUserContext';

import DownloadLink from '../../components/common/DownloadLink';
import useNavProject from '../../hooks/useNavProject';
import { status_ru_m } from '../../helpers/factdata';
import ForbiddenAccess from '../../components/ForrbiddenAccessComponent/ForbiddenAccess';
import ToolbarInfo from '../../components/table/ToolbarInfo';

const options = [
  {
    value: '',
    label: 'Все статусы'
  },
  ...Object.entries(status_ru_m)
    .map(([key, value]) => ({
      value: key,
      label: value
    })),
];

export default function RegistryMembers() {
  const [year, setYear] = useState(2025);
  const [editMemberID, setEditMemberID] = useState(null);
  const [portf, setPortf] = useState(null);
  const {
    stratId,
    portfolioId,
    policyId
  } = useParams();
  const tableRef = useRef();
  const navProject = useNavProject();
  const [filterStatus, setFilterStatus] = useState(options[0]);
  const [approvedMembersSp, setApprovedMembersSp] = useState();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!!tableRef.current) {
      tableRef.current?.onQueryChange({
        ...tableRef.current.state.query, ...{
          year,
          filterStatus: filterStatus.value
        }
      });
    }
  }, [year, filterStatus]);

  useEffect(() => {

    const fetchData = async () => {
      if (!stratId) return;
      if (portfolioId) {
        const respPortfolio = await api.get(`/structure/portfolios/${portfolioId}?latest=true`);
        if (!respPortfolio || respPortfolio.error) return;
        setPortf(respPortfolio);
        // setNavCtx({strategy: respPortfolio.strategy, portfolio: respPortfolio});
        navProject.setStratTitle(respPortfolio.strategy.name);
        navProject.setPortfolioTitle(respPortfolio.name);
      } else {
        const result = await api.get(`/info/strategies/${stratId}`);
        if (!result || result.error) return;
        navProject.setStratNumber(result.num);
        navProject.setStratTitle(result.name);
      }
    };
    fetchData();
  }, [stratId, portfolioId]);

  const registry = useMemo(() => (
    <TableRegistry tableRef={tableRef} setApprovedMembersSp={setApprovedMembersSp} filterStatus={filterStatus.value} year={year} setEditMemberID={setEditMemberID}/>
  ), [filterStatus, year]);
  const registryHeader = useMemo(() => `Участники ${portfolioId ? `команды` :
    (isLoaded || navProject.stratNumber) ? `${navProject.stratNumber ?? ''} ${navProject.stratTitle ?? ''}`
      : policyId ? 'проектов Политики в области цифровой трансформации' : ''
  }`, [navProject]);
  return (
    <section className="page strat-proj-report-page">
      <div style={{ padding: '3em' }}>
        <div style={{ marginBottom: 16 }}>
          {!editMemberID ? (
            <BackBtn/>
          ) : (
            <div className="back-btn">
              <button onClick={() => setEditMemberID(null)}>Вернуться назад</button>
            </div>
          )}
        </div>
        {editMemberID && <h3 style={styledHeading}>Редактировать участника</h3>}
        {!editMemberID && (
          <>
            <h3 style={styledHeading}>{registryHeader}</h3>
            <div className="d-flex flex-column">
              {<ToolbarInfo additionalCounter={approvedMembersSp} title={`Количество участников ${policyId ? 'политики' : 'стратегического проекта'}`}/>}
              <div style={styledContainer} className="d-flex align-items-end flex-wrap">
                <div style={{ minWidth: '144px' }}>
                  <div style={{
                    color: 'black',
                    fontSize: '16px',
                    marginBottom: '10px',
                    fontWeight: '600'
                  }}>Год
                  </div>
                  <YearSelect year={year} years={years} onChange={(e) => {
                    setYear(e.value);
                  }}/>
                </div>
                <div style={{
                  minWidth: '200px',
                  marginLeft: '16px'
                }}>
                  <div style={{
                    color: 'black',
                    fontSize: '16px',
                    marginBottom: '10px',
                    fontWeight: '600',
                  }}
                  >
                    Статус
                  </div>
                  <Select
                    defaultValue={filterStatus}
                    options={options}
                    onChange={(e) => {
                      setFilterStatus(e);
                    }}
                  />
                </div>
                <div style={{ marginLeft: '16px' }}>
                  <DownloadLink
                    variant="outline-primary"
                    url={`/factdata/teammembers/0/export?portfId=${portfolioId}&strategyId=${stratId}&year=${year}&policyId=${policyId}`}
                    filename={`Участники ${portfolioId ? 'команды портфель проектов ' + '(' + portf?.name + ')' : stratId ? 'СП' + '(' + stratId + ')' : `политики ${policyId}`}_${moment()
                      .format(
                        'DD.MM.yyyy'
                      )}.xlsx`}
                  >
                    Выгрузить в xls
                  </DownloadLink>
                </div>
              </div>
            </div>
            {registry}
          </>
        )}
        {editMemberID && <EditMember id={editMemberID} closeCard={() => setEditMemberID(null)}/>}
      </div>
    </section>
  );
}

const styledHeading = {
  marginBottom: 24,
  textAlign: 'left',
  color: '#0C0065'
};
const styledContainer = {
  display: 'flex',
  zIndex: 21,
  position: 'relative',
  top: 70,
  marginTop: -70,
  marginBottom: '20px',
};

